import trackBehavior from './trackLog';

const defaultAction = 'click';

export default function useDirective(Vue: any) {
    // 用户行为埋点指令
    Vue.directive('track', {
        bind(el: Element, binding: any) {
            const bValue = binding.value;
            if (!bValue) {
                return console.warn('v-track需要传递数据！');
            }
            el.addEventListener(bValue.action || defaultAction, () => {
                trackBehavior(bValue);
            });
        },
    });
};